import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex h-100 w-100" }
const _hoisted_2 = { class: "fp-sidenav" }
const _hoisted_3 = { class: "col px-0 h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FPSideNav = _resolveComponent("FPSideNav")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _component_NewConversation = _resolveComponent("NewConversation")!
  const _component_FPThreadsContainer = _resolveComponent("FPThreadsContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ScrollPagination, {
        class: "content-y h-100 d-flex flex-column w-100",
        "page-number": _ctx.pageNumber,
        "all-pages-loaded": _ctx.allPagesLoaded,
        "is-loading": _ctx.isLoading || _ctx.isLoadingMoreConversations,
        "has-error": _ctx.hasError,
        onPageNumberUpdate: _ctx.pageNumberUpdated
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FPSideNav, {
            conversationGroupsCount: _ctx.conversationGroupsCount,
            groupConversations: _ctx.groupConversations,
            selectedGroupType: _ctx.selectedGroupType,
            "onUpdate:selectedGroupType": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroupType) = $event)),
            selectedConversation: _ctx.selectedConversation,
            "onUpdate:selectedConversation": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedConversation) = $event)),
            openNewConversation: _ctx.openNewConversation,
            "onUpdate:openNewConversation": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openNewConversation) = $event)),
            "is-loading": _ctx.isLoading,
            "is-loading-more-conversations": _ctx.isLoadingMoreConversations,
            "loading-new-group": _ctx.loadingNewGroup,
            "page-number": _ctx.pageNumber,
            onTermChanged: _ctx.updateChatSearchTerm
          }, null, 8 /* PROPS */, ["conversationGroupsCount", "groupConversations", "selectedGroupType", "selectedConversation", "openNewConversation", "is-loading", "is-loading-more-conversations", "loading-new-group", "page-number", "onTermChanged"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["page-number", "all-pages-loaded", "is-loading", "has-error", "onPageNumberUpdate"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      (_ctx.openNewConversation)
        ? (_openBlock(), _createBlock(_component_NewConversation, {
            key: 0,
            selectedGroupType: _ctx.selectedGroupType
          }, null, 8 /* PROPS */, ["selectedGroupType"]))
        : (_openBlock(), _createBlock(_component_FPThreadsContainer, {
            key: 1,
            conversationThreadsInfo: _ctx.conversationThreadsInfo,
            selectedConversationId: _ctx.selectedConversation?.id,
            selectedConversation: _ctx.selectedConversation,
            selectedGroupType: _ctx.selectedGroupType,
            isLoading: _ctx.isLoading,
            isLoadingThreads: _ctx.isLoadingThreads,
            familyContacts: _ctx.familyContacts
          }, null, 8 /* PROPS */, ["conversationThreadsInfo", "selectedConversationId", "selectedConversation", "selectedGroupType", "isLoading", "isLoadingThreads", "familyContacts"]))
    ])
  ]))
}